import { ActivatedRouteSnapshot, ResolveFn, RouterStateSnapshot } from '@angular/router';
import { inject } from '@angular/core';
import { LicenseSessionsService } from '../services/license-sessions.service';

export const LicenseSessionsResolver: ResolveFn<any> = (
  route?: ActivatedRouteSnapshot,
  state?: RouterStateSnapshot,
  licenseSessionsService: LicenseSessionsService = inject(LicenseSessionsService)
): Promise<any> => {
  return new Promise((resolve, reject) => {
    const licenseId = route.paramMap.get('licenseId');
    if (licenseId) {
      return resolve(
        licenseSessionsService.loadReportData(licenseId).catch(() => reject('license sessions not found'))
      );
    }
    return reject('license id not found');
  });
};
